Ext.USE_NATIVE_JSON = true;

Ext.getDoc().on('dragstart', Ext.emptyFn, null, {preventDefault: true});

(async function() {
    var controllers = ['MenuController'],
        appLoadMask, bootErrorObserver;

    Ext.onDocumentReady(() => {
        document.body.style.backgroundColor = '#f5f5f8'; 

        SA.Viewport.initialize();

        bootErrorObserver = SA.BootErrorObserver.create(onBootError);

        appLoadMask = Ext.widget({
            xtype: 'load-mask',
            zIndex: 1000,
            renderTo: Ext.getBody(),
            backgroundColor: 'rgba(51, 61, 79, 0.6)'
        });
    });

    SA.userData = await SA.Ajax.request({resource: 'user'}).catch(() => {
        SA.logout();

        return null;
    });

    if (!SA.userData) {
        return;
    }

    function onBootError() {
        SA.Ajax.disable();
        appLoadMask.destroy();
        Ext.widget('boot-error-popup');
    }

    Ext.application({
        appFolder: 'static/js',
        autoCreateViewport: false,
        name: 'SA',

        controllers,

        async launch() {
            if (Ext.isWindows) {
                Ext.getBody().addCls('x-win');
            }

            SA.EventBus = new Ext.util.Observable();

            SA.Sidebar = Ext.widget({xtype: 'sidebar', renderTo: Ext.getBody()});
            SA.PageHeader = Ext.widget({xtype: 'page-header', renderTo: Ext.getBody()});
            SA.ProjectViewToolbar = Ext.widget({xtype: 'project-view-toolbar', renderTo: Ext.getBody()});
            SA.ViewChooser = Ext.widget({xtype: 'view-chooser', renderTo: Ext.getBody()});

            SA.FocusVisibilityToggler.init();
            SA.data.Projects.initialize();
            SA.MessageWindowManager.initialize();
            SA.AppController.initialize();
            SA.HiddenDom.initialize();
            SA.FontPreloader.preload();
            SA.BackNavigationHandler.initialize();
            SA.AttributeBadges.initialize();
            SA.ModeIndicator.initialize();
            SA.ProjectViewContainmentObserver.initialize();

            await SA.Loader.load();

            elasticApm.setUserContext({id: SA.User.getId()});

            SA.Institution.maybeRemoveDMAs();

            SA.AppController.openLastViewedOrNewProject();
            appLoadMask.destroy();
            bootErrorObserver.destroy();

            this.initNotices();
            this.loadData();
            this.initializeIntegrations();
        },

        async importIf(condition, ...srcs) {
            if (condition) {
                await Promise.all(srcs.map(src => import(/* webpackIgnore: true */ src)));
            }
        },

        initializeIntegrations() {
            SA.Heap.identifyUser(SA.User);

            SA.Olark.initialize();
            SA.Wootric.initialize();
            SA.Zendesk.initialize();
        },

        initNotices() {
            var notices = SA.User.getAdHocNotices(),
                shouldCountNoticeInBadge = notice => notice.isUnlistedNonAutoShowNotice();

            SA.PageHeader.getNotificationsBadgeCount = () => notices.filter(shouldCountNoticeInBadge).length;

            SA.NotificationsMenuController.create({pageHeader: SA.PageHeader, notifications: notices});
            SA.view.Notices.maybeShow();
        },

        loadData() {
            var loadables = [
                SA.data.DmaLocations,
                SA.data.quickreport.QuickReportTemplates,
                SA.data.FavoriteAttributes,
                SA.data.RecentAttributes,
                SA.data.FavoriteLocations,
                SA.data.RecentLocations
            ];

            loadables.forEach((loadable, index) => {
                var delay = (index + 1) * 250;

                setTimeout(() => loadable.loadAll(), delay);
            });
        }
    });
})();